import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=c0352fd8"
import script from "./comments.vue?vue&type=script&lang=js"
export * from "./comments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports